import React, { useEffect, useState } from "react";

import { Box, useTheme, Checkbox, Divider, Tooltip, Stack, Grid, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, TextField, FormControl, IconButton, Autocomplete, Button } from "@mui/material";

import { tokens } from "../../../theme/theme";
import CustomTableContainer from "../../../Layout/CustomTableContainer";

import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import ResponsiveBox from "../../../Layout/ResponsiveScrollBox";
import CallAlertBar from "../../../Layout/Alertbar";

import Close from '@mui/icons-material/Close';
import AppBarModule from "../../../Layout/AppbarModule";
import useDepartments from "../../../hooks/useGetAllDepartmentList";
import useLocations from "../../../hooks/useLocations";
import useEmployee from "../../../hooks/useEmployee";
import useShiftRoasterByDepartment from "../../../hooks/useRoasterListByDepartment";
import useShiftRoasterEmployeeListByDepartment from "../../../hooks/useEmployeeListByDepartmentID";
import useShiftEmployeeAssignment from "../../../hooks/useShiftEmployeeAssignment";
import useAssignmentStatus from "../../../hooks/useAssignmentStatus";
import ReceiptRoundedIcon from '@mui/icons-material/ReceiptRounded';

const ShiftEmployeeAssignmentForm = ({ handleBackWinderMachineEntry }) => {


    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    // state variable declartion
    const [rosterList, setRoasterList] = useState([]);
    const [selectedRoasterCode, setSelectedRoasterCode] = useState('');
    const [editShiftAssignmentID, setShiftAssignmentID] = useState(0);

    const [newShift, setNewShift] = useState(false);
    const [assignmentDate, setAssignmentDate] = useState(dayjs().format('DD/MMM/YYYY'));
    const [selectedButton, setSelectedButton] = useState(null);

    // departement
    const [statusList, setStatusList] = useState([]);
    const [selectedStatus, setSelectedStatus] = useState('All');


    // message Process
    const [msgOpen, setMsgOpen] = useState(false);
    const [severityValue, setSeverityvalue] = useState('info');
    const [messageValue, setMessageValue] = useState('Welcome to Paper Roll Booking! ');
    const [alertTitleValue, setAlertTitleValue] = useState('');

    const [selectedRows, setSelectedRows] = useState([]);
    const [title, setTitle] = useState('Add Shift Employee Assignment');
    const [roasterId, setRoasterId] = useState(0);
    const handleShowNewVendor = async () => {
        setNewShift(true);
        setRoasterId(0);
        await callRefreshData();
    }

    // call message
    const CallMessage = (serverityval, msg, title) => {
        setSeverityvalue(serverityval);
        setMessageValue(msg);
        setAlertTitleValue(title);
        setMsgOpen(true);
    };


    const { locations, selectedLocation, selectedLocationID, setSelectedLocation, setSelectedLocationID, loadLocationByID } = useLocations(editShiftAssignmentID);
    const { departments, selectedDepartment, selectedDepartmentID, setSelectedDepartment, setSelectedDepartmentID, loadDepartmentByID } = useDepartments(editShiftAssignmentID);
    const { employee, selectedEmployee, selectedEmployeeID, setSelectedEmployee, setSelectedEmployeeID, loadEmployeeByID } = useEmployee(editShiftAssignmentID);
    const { shiftRoaster, selectedShiftRoaster, selectedShiftRoasterID, setSelectedShiftRoaster, setSelectedShiftRoasterID, loadShiftRoasterByID, loadShiftRosterByDepartmentID } = useShiftRoasterByDepartment(editShiftAssignmentID, selectedDepartmentID);
    const { assignmentStatus, selectedassignmentStatus, selectedassignmentStatusID, setSelectedAssignmentStatus, setSelectedAssignmentStatusID, loadAssignmentStatusByID } = useAssignmentStatus(editShiftAssignmentID);
    const { employeeList, loadEmployeeListShiftRosterByDepartmentID } = useShiftRoasterEmployeeListByDepartment(editShiftAssignmentID, selectedDepartmentID);
    const { insertShiftAssignment, updateShiftAssignment, shiftEmployeeAssignmentlist, SelectedShiftEmployeeAssignmentDetails, SelectedshiftEmployeeAssignmentlist, loading, error } = useShiftEmployeeAssignment();


    // insert and update shift master detail


    // Insert project details
    const handleSubmit = async () => {

        //load employee list  isSelected
        const selectedEmployees = employeeList.filter((emp) => selectedRows.includes(emp.id_employee));
        const payload = {
            p_location_id: selectedLocationID,
            p_department_id: selectedDepartmentID,
            p_employee_id: selectedEmployees,
            p_roaster_id: selectedShiftRoasterID,
            p_assignment_date: dayjs(assignmentDate).format('YYYY-MM-DD hh:mm:ss'),
            p_status_id: selectedassignmentStatusID,
            p_companyid: localStorage.getItem('companyid') || 0,
            p_plantid: 1,
            p_assignment_id: editShiftAssignmentID || 0,
        };
        let response;
        if (editShiftAssignmentID === 0) {
            response = await insertShiftAssignment(payload);
        }
        else {
            response = await updateShiftAssignment(payload);
        }

        if (response.success) {
            // success message

            if (editShiftAssignmentID === 0) {
                CallMessage('success', 'Shift Employee assignment saved successfully', 'Info');
                setShiftAssignmentID(response.data[0].assignment_id);
            }
            else {
                CallMessage('success', 'Shift Employee assignment update successfully', 'Info');
            }

        }
        else {
            alert(`Error:${response.error}`);
        }
    }

    // location change
    const handlechangeLocation = (event, value) => {
        if (!value) {
            setSelectedLocation(null);
            setSelectedLocationID(null);
            return; // Exit early if value is null
        }
        setSelectedLocation(value);
        setSelectedLocationID(value.id);
    }

    // department change
    const handleDepartmentChange = async (event, value) => {
        if (!value) {
            setSelectedDepartment(null);
            setSelectedDepartmentID(null);
            return; // Exit early if value is null
        }

        setSelectedDepartment(value);
        setSelectedDepartmentID(value.id);

        await loadShiftRosterByDepartmentID(value.id);
        await loadEmployeeListShiftRosterByDepartmentID(value.id);
    };



    const handleShiftRoasterChange = (event, value) => {
        if (!value) {
            setSelectedShiftRoaster(null);
            setSelectedShiftRoasterID(null);
            return; // Exit early if value is null
        }
        setSelectedShiftRoaster(value);
        setSelectedShiftRoasterID(value.id);

    }

    // assignment status
    const handleShiftAssignmentStatusChange = (event, value) => {
        if (!value) {
            setSelectedAssignmentStatus(null);
            setSelectedAssignmentStatusID(null);
            return; // Exit early if value is null
        }
        setSelectedAssignmentStatus(value);
        setSelectedAssignmentStatusID(value.id);
    }


    //call back Form
    const callback = async () => {
        await callRefreshData();
        handleBackWinderMachineEntry();
    };

    const callBackNewShift = async () => {
        await callRefreshData();
        setNewShift(false);
    };

    const callRefreshData = async () => {
        setSelectedDepartment(null);
        setSelectedDepartmentID(null);
        setSelectedAssignmentStatus(null);
        setSelectedAssignmentStatusID(null);
        setSelectedShiftRoaster(null);
        setSelectedShiftRoasterID(null);
        setSelectedLocation(null);
        setSelectedLocationID(null);
        await loadEmployeeListShiftRosterByDepartmentID(0);
        setShiftAssignmentID(0);
        setSelectedRows([]); // Reset selectedRows to an empty array
    }
   

    const [filters, setFilters] = useState({
        shiftCode: '',
        description: '',

    });

    const filteredData = employeeList.filter((row) => {
        // Check if row matches selected status
        if (selectedStatus === 'All' || row.status === selectedStatus) {
            // Check if all filter fields match
            return Object.keys(filters).every((key) => {
                if (filters[key] === '') return true; // No filter applied
                return String(row[key]).toLowerCase().includes(filters[key].toLowerCase());
            });
        }
        return false;
    });

    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            const newSelectedRows = employeeList.map((row) => row.id_employee);
            setSelectedRows(newSelectedRows);
            return;
        }
        setSelectedRows([]);
    };
    const handleRowCheckboxClick = (event, rowId) => {
        const selectedIndex = selectedRows.indexOf(rowId);
        let newSelectedRows = [];

        if (selectedIndex === -1) {
            newSelectedRows = [...selectedRows, rowId];
        } else if (selectedIndex === 0) {
            newSelectedRows = selectedRows.slice(1);
        } else if (selectedIndex === selectedRows.length - 1) {
            newSelectedRows = selectedRows.slice(0, -1);
        } else if (selectedIndex > 0) {
            newSelectedRows = [
                ...selectedRows.slice(0, selectedIndex),
                ...selectedRows.slice(selectedIndex + 1),
            ];
        }

        setSelectedRows(newSelectedRows);

    };

    const isSelected = (rowId) => selectedRows.indexOf(rowId) !== -1;

    const handleCallEdit = async (value) => {
        // setShiftID(value);
        setTitle('Update Shift Employee Assignment');
        setRoasterId(value.p_roaster_id);
        setShiftAssignmentID(value.id_assignment);
        setNewShift(true);

        locations.map((loc) => {
            if (loc.description === value.location) {
                setSelectedLocation(loc);
                setSelectedLocationID(loc.id);
            }
        });

        let deptid;
        departments.map((dept) => {
            if (dept.description === value.department) {
                setSelectedDepartment(dept);
                setSelectedDepartmentID(dept.id);
                deptid = dept.id;

            }
        });

        assignmentStatus.map((status) => {
            if (status.description === value.status) {
                setSelectedAssignmentStatus(status);
                setSelectedAssignmentStatusID(status.id);
            }
        });


        setAssignmentDate(dayjs(value.assignment_date).format('DD/MMM/YYYY'));

        await loadShiftRosterByDepartmentID(deptid);
        await loadEmployeeListShiftRosterByDepartmentID(deptid);

        const para = {
            p_companyid: localStorage.getItem("companyid"),
            p_assignment_id: value.id_assignment,
        };

        await SelectedShiftEmployeeAssignmentDetails(para);


    };

    useEffect(() => {
        if (SelectedshiftEmployeeAssignmentlist.length > 0) {
            setSelectedRows(SelectedshiftEmployeeAssignmentlist.map((emp) => emp.id_employee)); // Set selectedRows to the list of employee IDs
        }

        if (shiftRoaster.length > 0) {
            shiftRoaster.map((roaster) => {
                if (roaster.id === roasterId) {
                    setSelectedShiftRoaster(roaster);
                    setSelectedShiftRoasterID(roaster.id);
                }
            });
        }

    }, [SelectedshiftEmployeeAssignmentlist, shiftRoaster, roasterId]);



    return (
        <Box sx={{ marginTop: "0px" }}>

            {newShift === false && (
                <>
                    <AppBarModule
                        title=" Shift Employee Assignment Management"
                        menuOptions={['All Shift Roaster', 'Active Shift Roaster', 'Inactive Shift Roaster']}
                        onNewClick={() => handleShowNewVendor()}
                        onClose={() => callback()}
                    />


                    {/* Message box detail */}
                    <CallAlertBar parentRollMsgOpen={msgOpen} setParentRollMsgOpen={setMsgOpen} parentRollSeverityvalue={severityValue}
                        setParentRollSeverityvalue={setSeverityvalue} parentRollAlertTitleValue={alertTitleValue}
                        setParentRollAlertTitleValue={setAlertTitleValue} parentRollMessageValue={messageValue} setParentRollMessageValue={setMessageValue} />
                </>
            )}

            <ResponsiveBox
                customMaxHeight={{
                    xs: '60vh',  // Custom value for extra small devices
                    sm: '65vh',  // Custom value for small devices
                    md: '70vh',  // Custom value for medium devices
                    lg: '91vh',  // Custom value for large devices
                    xl: '93vh',  // Custom value for extra large devices
                }}>

                <Grid>
                    {newShift === false && (
                        <>
                            <Grid item xs={12} sm={6} md={4} lg={2}>
                                <CustomTableContainer colors={colors}>
                                    <TableContainer>
                                        <Table>
                                            <TableHead sx={{ height: 10 }}>
                                                <TableRow>
                                                    <TableCell>ID</TableCell>
                                                    <TableCell>Assignment Date</TableCell>
                                                    <TableCell>Location</TableCell>
                                                    <TableCell>Department</TableCell>
                                                    <TableCell>Roaster Start Date</TableCell>
                                                    <TableCell>Roaster End Date</TableCell>
                                                    <TableCell>Total Employees</TableCell>
                                                    <TableCell>Status </TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {shiftEmployeeAssignmentlist.map((s) => (
                                                    <React.Fragment key={s.id_assignment}>
                                                        <TableRow>
                                                            <TableCell>
                                                                <span
                                                                    style={{ color: 'teal', textDecoration: 'underline', cursor: 'pointer' }}
                                                                    onClick={() => handleCallEdit(s)}
                                                                >
                                                                    {s.id_assignment}
                                                                </span>
                                                            </TableCell>
                                                            <TableCell>{dayjs(s.assignment_date).format("DD-MMM-YYYY")}</TableCell>
                                                            <TableCell>{s.location}</TableCell>
                                                            <TableCell>{s.department}</TableCell>
                                                            <TableCell>{dayjs(s.start_date).format("DD-MMM-YYYY")}</TableCell>
                                                            <TableCell>{dayjs(s.end_date).format("DD-MMM-YYYY")}</TableCell>
                                                            <TableCell>{s.total_employees}</TableCell>
                                                            <TableCell>{s.status}</TableCell>
                                                        </TableRow>
                                                    </React.Fragment>
                                                ))}

                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </CustomTableContainer>
                            </Grid>
                        </>
                    ) || (
                            <>
                                <Grid item xs={12} sm={6} md={4} lg={2}  >

                                    <Grid container justifyContent="space-between" alignItems="center" padding={0}>
                                        {/* Left-aligned: Edit Employee */}
                                        <Grid item>
                                            <Typography variant="h4" sx={{ textAlign: "center", width: "100%", marginLeft: "10px", alignItems: "center" }}>
                                                {/* {editShiftID === 0 ? 'Add Shift Detail' : 'Edit Shift Detail'} */}
                                                {title}
                                            </Typography>
                                        </Grid>

                                        {/* Right-aligned: Buttons */}
                                        <Grid item>
                                            <Grid container alignItems="center">
                                                <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />
                                                {/* Save */}
                                                <Grid item ml={1} mr={1}>
                                                    <Tooltip title="Add new orders">
                                                        <IconButton
                                                            onClick={() => handleSubmit()}
                                                            sx={{ display: 'flex', alignItems: 'center' }}
                                                            type="submit"
                                                        // disabled={saveButtonDisabled}
                                                        >
                                                            <ReceiptRoundedIcon style={{ fontSize: "18px", color: selectedButton === 'save' ? "yellow" : "#009688" }} />
                                                            <Typography variant="body2" sx={{ ml: 1 }}>  {editShiftAssignmentID === 0 ? 'Save' : 'Edit'}</Typography>
                                                        </IconButton>
                                                    </Tooltip>
                                                </Grid>

                                                <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />

                                                <IconButton onClick={callBackNewShift}>
                                                    {/* onClick={callback} */}
                                                    <Close style={{ fontSize: "14px", color: "#2196F3" }} />
                                                </IconButton>
                                                <Divider orientation="vertical" flexItem
                                                // sx={{ mx: 1 }}
                                                />
                                            </Grid>
                                        </Grid>
                                    </Grid>

                                    <Divider />
                                    <CallAlertBar parentRollMsgOpen={msgOpen} setParentRollMsgOpen={setMsgOpen} parentRollSeverityvalue={severityValue}
                                        setParentRollSeverityvalue={setSeverityvalue} parentRollAlertTitleValue={alertTitleValue}
                                        setParentRollAlertTitleValue={setAlertTitleValue} parentRollMessageValue={messageValue} setParentRollMessageValue={setMessageValue} />
                                </Grid>


                                {/* Add Form detail */}
                                <Grid item xs={12} sm={6} md={4} lg={2}>
                                    <Grid container>
                                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12} mt={2}>
                                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                                                <Grid container padding="10px 0px 10px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center" >

                                                    <Grid item xs={12} sm={12} md={2.5} lg={1.5} xl={1} display="flex-start" justifyContent="center">
                                                        <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                                            Location
                                                        </Typography>
                                                    </Grid>

                                                    <Grid item xs={12} sm={11} md={3.8} lg={3} xl={2}>
                                                        <FormControl fullWidth size="small">
                                                            <Autocomplete
                                                                fullWidth
                                                                value={selectedLocation}
                                                                onChange={handlechangeLocation}
                                                                size="small"
                                                                style={{ fontSize: '12px' }}
                                                                options={locations}
                                                                getOptionLabel={(option) => `${option.description || ''}`}
                                                                renderInput={(params) =>
                                                                    <TextField required
                                                                        {...params} variant="outlined" />}
                                                            />
                                                        </FormControl>
                                                    </Grid>
                                                </Grid>

                                            </Grid>

                                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                                                <Grid container padding="10px 0px 10px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center" >

                                                    <Grid item xs={12} sm={12} md={2.5} lg={1.5} xl={1} display="flex-start" justifyContent="center">
                                                        <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                                            Departement
                                                        </Typography>
                                                    </Grid>

                                                    <Grid item xs={12} sm={11} md={3.8} lg={3} xl={2}>
                                                        <FormControl fullWidth size="small">
                                                            <Autocomplete
                                                                fullWidth
                                                                value={selectedDepartment}
                                                                onChange={handleDepartmentChange}
                                                                size="small"
                                                                style={{ fontSize: '12px' }}
                                                                options={departments}
                                                                getOptionLabel={(option) => `${option.description || ''}`}
                                                                renderInput={(params) =>
                                                                    <TextField required
                                                                        {...params} variant="outlined" />}
                                                            />
                                                        </FormControl>
                                                    </Grid>
                                                </Grid>

                                            </Grid>                                            

                                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                                                <Grid container padding="10px 0px 10px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center" >

                                                    <Grid item xs={12} sm={12} md={2.5} lg={1.5} xl={1} display="flex-start" justifyContent="center">
                                                        <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                                            Roaster
                                                        </Typography>
                                                    </Grid>

                                                    <Grid item xs={12} sm={11} md={3.8} lg={3} xl={2}>
                                                        <FormControl fullWidth size="small">
                                                            <Autocomplete
                                                                fullWidth
                                                                value={selectedShiftRoaster}
                                                                onChange={handleShiftRoasterChange}
                                                                size="small"
                                                                style={{ fontSize: '12px' }}
                                                                options={shiftRoaster}
                                                                getOptionLabel={(option) => `${option.shift_roster_code || ''}`}
                                                                renderInput={(params) =>
                                                                    <TextField required
                                                                        {...params} variant="outlined" />}
                                                            />
                                                        </FormControl>
                                                    </Grid>
                                                </Grid>

                                            </Grid>

                                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                                                <Grid container padding="10px 0px 10px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center" >

                                                    <Grid item xs={12} sm={12} md={2.5} lg={1.5} xl={1} display="flex-start" justifyContent="center">
                                                        <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                                            Assignment Date
                                                        </Typography>
                                                    </Grid>

                                                    <Grid item xs={12} sm={11} md={3.8} lg={3} xl={2}>
                                                        <FormControl fullWidth size="small">
                                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                                <Stack spacing={1}>
                                                                    <DatePicker
                                                                        value={dayjs(assignmentDate)} // Ensure shiftDate is a valid Day.js object or compatible string
                                                                        onChange={(date) => setAssignmentDate(date)}
                                                                        slotProps={{
                                                                            textField: {
                                                                                size: "small",
                                                                                variant: "outlined",
                                                                                fullWidth: true, // Add fullWidth here if needed
                                                                            },
                                                                        }}
                                                                        format="DD-MMM-YYYY" // For date formatting
                                                                        minDate={dayjs().subtract(4, 'year')}
                                                                        maxDate={dayjs().add(1, 'year')}
                                                                    />
                                                                </Stack>
                                                            </LocalizationProvider>
                                                        </FormControl>
                                                    </Grid>
                                                </Grid>

                                            </Grid>


                                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                                                <Grid container padding="10px 0px 10px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center" >

                                                    <Grid item xs={12} sm={12} md={2.5} lg={1.5} xl={1} display="flex-start" justifyContent="center">
                                                        <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                                            Status
                                                        </Typography>
                                                    </Grid>

                                                    <Grid item xs={12} sm={11} md={3.8} lg={3} xl={2}>
                                                        <FormControl fullWidth size="small">
                                                            <Autocomplete
                                                                fullWidth
                                                                value={selectedassignmentStatus}
                                                                onChange={handleShiftAssignmentStatusChange}
                                                                size="small"
                                                                style={{ fontSize: '12px' }}
                                                                options={assignmentStatus}
                                                                getOptionLabel={(option) => `${option.description || ''}`}
                                                                renderInput={(params) =>
                                                                    <TextField required
                                                                        {...params} variant="outlined" />}
                                                            />
                                                        </FormControl>
                                                    </Grid>
                                                </Grid>

                                            </Grid>

                                        </Grid>

                                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12} mt={2}>
                                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                                                <Grid container padding="10px 0px 10px 0px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center" >
                                                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12} display="flex-start" justifyContent="center">
                                                        <Divider />
                                                    </Grid>
                                                </Grid>
                                            </Grid>

                                            <Grid item xs={12} sm={12} md={12} lg={6} xl={5} mt={0.2}>
                                                <CustomTableContainer colors={colors}>
                                                    <TableContainer>
                                                        <Table  >
                                                            <TableHead sx={{ height: 10 }}>
                                                                <TableRow>
                                                                    <TableCell sx={{ textAlign: 'center' }}>
                                                                        <Checkbox size="small" style={{ color: "secondary" }}
                                                                            indeterminate={selectedRows.length > 0 && selectedRows.length < filteredData.length}
                                                                            checked={selectedRows.length === filteredData.length}
                                                                            onChange={handleSelectAllClick}
                                                                        />
                                                                    </TableCell>
                                                                    <TableCell >No</TableCell>
                                                                    <TableCell>Employee Code</TableCell>
                                                                    <TableCell>Employee Name</TableCell>
                                                                    <TableCell>Designation</TableCell>
                                                                   
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody >
                                                                {filteredData.map((s) => (
                                                                    <React.Fragment key={s.id_employee}>
                                                                        <TableRow  >
                                                                            <TableCell sx={{ textAlign: 'center' }}>
                                                                                <Checkbox
                                                                                    size="small"
                                                                                    checked={isSelected(s.id_employee)}
                                                                                    onChange={(event) => handleRowCheckboxClick(event, s.id_employee)}
                                                                                />
                                                                            </TableCell>
                                                                            <TableCell sx={{ textAlign: 'center' }} >{s.id_employee}</TableCell>
                                                                            <TableCell>{s.employee_code}</TableCell>
                                                                            <TableCell>{s.employee_name}</TableCell>
                                                                            <TableCell sx={{ textAlign: 'center' }} >{s.designation}</TableCell>
                                                                            

                                                                        </TableRow>
                                                                    </React.Fragment>
                                                                ))}

                                                            </TableBody>
                                                        </Table>
                                                    </TableContainer>
                                                </CustomTableContainer>
                                            </Grid>
                                            
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </>
                        )}
                </Grid>

            </ResponsiveBox>
        </Box>
    );

}
export default ShiftEmployeeAssignmentForm;